<script setup lang="ts">
import { ActionFields } from '~/components/cms/Action/actionHelpers'

export type HeroPanelStandardContentOnlyProps = {
  tagline?: string
  titleMD: string
  text: string
  action?: ActionFields
  supportingData?: {
    home: {
      width?: {
        value: WidthVariants
      }
    }
  }
}

const props = defineProps<HeroPanelStandardContentOnlyProps>()
</script>

<template>
  <section class="hero-panel-standard-content-only">
    <div class="container">
      <div class="hero-panel__content">
        <p class="hero-panel__tagline" v-if="tagline">{{ tagline }}</p>
        <Markdown class="hero-panel__title" :content="titleMD" tag="h1" />
        <Markdown class="hero-panel__text" :content="text" />
        <Action class="hero-panel__action" v-if="action" v-bind="action" :button="{ appearance: 'Button' }" />
      </div>
    </div>
  </section>
</template>

<style lang="postcss">
@import '~/assets/css/placeholders.css';

.hero-panel-standard-content-only {
  padding-block: var(--space-50) var(--space-70);

  .hero-panel__content {
    max-width: 25rem;
    p:last-child {
      margin-bottom: 0;
    }
  }

  .hero-panel__tagline {
    letter-spacing: var(--letter-spacing-2);
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: var(--space-30);
  }

  .hero-panel__title {
    margin-bottom: var(--space-50);

    > p {
      margin-bottom: 0; /* p that may come from Markdown formatting */
    }
  }

  .hero-panel__text {
    @extend %body;
  }

  @media (--tablet) {
    padding-block: var(--space-70);
  }

  @media (--desktop) {
    .hero-panel__content {
      max-width: 27rem;
    }
  }
}
</style>
